import { Box, Flex } from '@chakra-ui/react';
import { useMemo, useState } from 'react';
import { Autocomplete } from '@material-ui/lab';

import { AutocompleteField, MultiSelectField, SelectField } from '@app/components/common';
import { useQueryTable } from '@app/components/common/table/query-table';
import { useAutocomplete, useGuide } from '@app/hooks';
import { OutletField } from '@app/pages/equipments/dialogs/components/OutletField';

export const FilterPanel = () => {
  const { filter, setFilter } = useQueryTable();

  const getStatuses = useGuide('outlet_status');
  const getAutocomplete = useAutocomplete(); 
  const [fastSearchedOutlets, setFastSearchedOutlets] = useState<EntityBase>();

  const status = useMemo(() => {
    return filter.find(({ name }) => name === 'status_id')?.value as EntityBase;
  }, [filter]);
  const distributor = useMemo(() => {
    return filter.find(({ name }) => name === 'distributor_id')?.value as EntityBase;
  }, [filter]);

  return (<>
    <Box minW='100%' pt={4}>
      <Flex gap={2}>
        <Box minW={200}>
          <SelectField
            id='status'
            label='Статус ТТ'
            value={status}
            onChange={(value) => {
              const newFilter = [...filter];
              newFilter.find(({ name }) => name === 'status_id').value = value;
              setFilter(newFilter);
            }}
            onFetchOptions={getStatuses}
            clearable={false}
          />
        </Box>
        <Box minW={200}>
          <AutocompleteField
            id='distributor'
            label='Дистрибьютор'
            name='distributor'
            value={distributor}
            onChange={(value) => {
              const newFilter = [...filter];
              newFilter.find(({ name }) => name === 'distributor_id').value = value;
              setFilter(newFilter);
            }}
            onFetchOptions={getAutocomplete}
          />
        </Box>
        <Box flex={1}>
          <OutletField
            id='outlet'
            label='Быстрый поиск'
            value={fastSearchedOutlets}          
            onChange={(value) => {
              setFastSearchedOutlets(value);
              const newFilter = [...filter];
              newFilter.find(({ name }) => name === 'id').value = value?.id?.toString();
              setFilter(newFilter);
            }}
            onFetchOptions={getAutocomplete}
            distributor_id={distributor?.id?.toString()}
            status={status?.id === 1 ? 'opened' : 'all'}
          />
        </Box>
      </Flex>
    </Box>
  </>);
};